import {
  BNKeyboardEvent,
  BNTouchEvent,
  GamepadAxisEvent,
  GamepadButtonEvent,
  GamepadConnectEvent,
  GamepadTriggerEvent,
  InputProvider,
  MouseClickEvent,
  PlayerWebRTC,
} from "@blacknut/playerwebrtc";

class VGamepadInputProvider implements InputProvider {
  player: PlayerWebRTC;
  constructor(player: PlayerWebRTC) {
    this.player = player;
  }

  private shouldConnect = true;

  connectIfNeed() {
    if (!this.shouldConnect) return;
    this.onGamepadConnect({ id: "virtual", index: 0 });
  }

  public teardown() {
    if (this.shouldConnect) return;
    this.onGamepadDisconnect({ id: "virtual", index: 0 });
  }

  onGamepadConnect(e: GamepadConnectEvent) {
    if (this.player.WebRTCClient.inputListener) {
      if (!this.player.WebRTCClient.inputListener.onGamepadConnect(e)) {
        return false;
      }
      this.shouldConnect = false;
      return true;
    }
    return false;
  }
  onGamepadDisconnect(e: GamepadConnectEvent) {
    if (this.player.WebRTCClient.inputListener) {
      this.player.WebRTCClient.inputListener.onGamepadDisconnect(e);
      this.shouldConnect = true;
    }
  }
  onGamepadButtonEvent(e: GamepadButtonEvent) {
    this.connectIfNeed();
    if (this.player.WebRTCClient.inputListener) {
      this.player.WebRTCClient.inputListener.onGamepadButtonEvent(e);
    }
  }
  onGamepadBackEvent(e: GamepadButtonEvent) {
    this.connectIfNeed();

    if (this.player.WebRTCClient.inputListener) {
      this.player.WebRTCClient.inputListener.onGamepadBackEvent(e);
    }
  }
  onGamepadTrigger(e: GamepadTriggerEvent) {
    this.connectIfNeed();

    if (this.player.WebRTCClient.inputListener) {
      this.player.WebRTCClient.inputListener.onGamepadTrigger(e);
    }
  }
  onGamepadAxis(e: GamepadAxisEvent) {
    this.connectIfNeed();

    if (this.player.WebRTCClient.inputListener) {
      this.player.WebRTCClient.inputListener.onGamepadAxis(e);
    }
  }
  onMouseClick(e: MouseClickEvent) {
    if (this.player.WebRTCClient.inputListener) {
      this.player.WebRTCClient.inputListener.onMouseClick(e);
    }
  }
  onKeyboardEvent(e: BNKeyboardEvent) {
    if (this.player.WebRTCClient.inputListener) {
      this.player.WebRTCClient.inputListener.onKeyboardEvent(e);
    }
  }
  onTouchEvent(e: BNTouchEvent) {
    if (this.player.WebRTCClient.inputListener) {
      this.player.WebRTCClient.inputListener.onTouchEvent(e);
    }
  }
  pause() {}
  resume() {}
}

export default VGamepadInputProvider;
